import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { AuthService } from 'src/app/core/services/auth.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-user-edit-modal',
  templateUrl: './user-edit-modal.component.html',
  standalone: false,
  providers: [DialogService] // Necessário para abrir o UnsavedChanges
})
export class UserEditModalComponent implements OnInit {
  @ViewChild('editForm') editForm: NgForm | undefined;

  model: any = {
    email: '',
    displayName: ''
  };

  /** Spinner do botão Save durante o submit. */
  submitting = false;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private authService: AuthService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    // Carrega dados passados pelo Sidebar ou busca do Auth
    if (this.config.data) {
        this.model.email = this.config.data.email;
        this.model.displayName = this.config.data.displayName;
    }
  }

  saveRecord() {
    if (!this.model.displayName) return;

    this.submitting = true;

    const updateDto = {
        displayName: this.model.displayName
    };

    this.authService.updateUser(updateDto).subscribe({
      next: () => {
        this.messageService.add({severity:'success', summary:'Success', detail:'Profile updated!'});
        this.submitting = false;
        if (this.editForm) this.editForm.form.markAsPristine();
        this.ref.close('success');
      },
      error: (err) => {
        this.submitting = false;
        console.error(err);
        this.messageService.add({severity:'error', summary:'Error', detail:'Failed to update profile.'});
      }
    });
  }
}
